import { SupportedLanguage } from '@/enum'
import { DropdownOption } from '@/types'

export const NADI_OPTIONS: DropdownOption = {
  [SupportedLanguage.English]: [],
  [SupportedLanguage.Hindi]: [],
  [SupportedLanguage.Bengali]: [],
  [SupportedLanguage.Telugu]: [],
  [SupportedLanguage.Marathi]: ['आद्य', 'मध्य', 'अंत्य'],
  [SupportedLanguage.Tamil]: [],
  [SupportedLanguage.Gujarati]: [],
  [SupportedLanguage.Kannada]: [],
  [SupportedLanguage.Malayalam]: [],
  [SupportedLanguage.Odia]: [],
}
